import { useRouter } from 'next/router';

import noticeError from 'utils/logger';
import orderTableStore from 'features/trade/components/OrderTable/store';
import tradingModalStore from 'global/TradingModal/store';
import tradingStore from 'lib/stores/trading';
import useSecuritiesCredentialStore from 'global/Securities/stores/useSecuritiesCredentialStore';
import useUIConfigStore from 'stores/useUIConfigStore';
import { LoginType } from 'typings/auth';
import { handleClickSupport } from 'utils/crisp';

export default function useSecuritiesButton() {
  const router = useRouter();
  const resetUIValue = useUIConfigStore((s) => s.resetUIValue);

  const handleLogoutTrading = async () => {
    try {
      await useSecuritiesCredentialStore.getState().loadLogout();
      const securitiesPathPattern = /securities\/.+/;
      const isSecuritiesPage = securitiesPathPattern.test(router.asPath);

      tradingStore.getState().resetErrorCode();
      tradingModalStore.getState().resetModal();
      orderTableStore.getState().resetOrderTableStore();

      // reset eipo token
      localStorage.removeItem('eipoToken');
      localStorage.removeItem('eipoRefreshToken');

      resetUIValue(LoginType.Securities);
      if (isSecuritiesPage) await router.push('/stream');

      return;
    } catch (error) {
      noticeError(error, {
        event: 'TradingMenuItem@handleNavigation',
        errType: error?.response?.data?.error_type,
        errMessage: error?.response?.data?.message,
      });
    }
  };

  const handleClickSupportButton = () => {
    handleClickSupport();
  };

  return {
    handleLogoutTrading,
    handleClickSupportButton,
  };
}
